// https://remysharp.com/2010/07/21/throttling-function-calls
export function throttle(fn, threshhold, scope) {
	// threshhold || (threshhold = 250);
	let last;
	let deferTimer;
	return function action(...args) {
		const context = scope || this;
		const _now = +new Date();
		if (last && _now < last + threshhold) {
			// hold on to it
			clearTimeout(deferTimer);
			deferTimer = setTimeout(() => {
				last = _now;
				fn.apply(context, args);
			}, threshhold);
		} else {
			last = _now;
			fn.apply(context, args);
		}
	};
}
